import api from "./api"

export const getFormEntriesByFormName = async (formName, filters = {}, { fields = '', page = 1, limit = 10 } = {}) => {
    if (formName === "school_profile") limit = 1;
    const params = { formName, page, limit }
    if (filters && Object.keys(filters).length > 0) {
        params["filters"] = JSON.stringify(filters)
    }
    if (fields && fields.length > 0) {
        params["fields"] = fields;
    }
    const res = await api.get(`/form-entries`, { params });
    return res?.data;
}

export const submitFormEntry = async (formName, payload) => {
    const payloadWithFormName = { formName, payload }
    const res = await api.post(`/form-entries`, payloadWithFormName);
    return res;
}

export const getFormEntriesByGroup = async (formName, groupBy, filters = {}) => {
    const params = { formName, groupBy }
    if (filters && Object.keys(filters).length > 0) {
        params["filters"] = JSON.stringify(filters)
    }
    const res = await api.get(`/form-entries/group`, { params });
    return res?.data;
}

export const fetchFormDefination = async (formName) => {
    try {
        const res = await api.get(`/form-definitions/name/${formName}`);
        if (res?.success) {
            return res?.data;
        };
        return null;
    } catch (err) {
        return null;
    }
}

export const fetchReferenceForm = async (formName) => {
    const params = { formName }
    const res = await api.get(`/form-entries`, { params });
    return res?.data;
}

export const fetchApiReferenceForm = async (endPoint) => {
    const res = await api.get(`${endPoint}`);
    return res?.data;
}

export const fileUpload = async (formData) => {
    const res = await api.post(`/file-upload`, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
    return res?.data;
}